<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_AVAILABLE_RESULTS'
        )
      }"
    >
      <textarea
        v-on:keyup="
          $parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_AVAILABLE_RESULTS'
          )
        "
        :disabled="$parent.$parent.projectDisabled"
        v-model="$parent.project.UF_AVAILABLE_RESULTS"
        class="i-main-style t-dop-style i-wid-50"
        style="height:70px;"
        :placeholder="getPlacholder()"
      ></textarea>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_AVAILABLE_RESULTS"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_available_results",
  methods: {
    getPlacholder() {
      if (
        this.$parent.$parent.getProgramCode(
          this.$parent.project.UF_SUPPORT_PROG_ID
        ) == "working" ||
        this.$parent.$parent.getProgramCode(
          this.$parent.project.UF_SUPPORT_PROG_ID
        ) == "working_rfrp"
      ) {
        return "Опишите существующие результаты по проекту. Укажите наличие прототипа опытно-промышленного образца, интеллектуальной собственности, бизнес-плана, технико-экономического обоснования для реализации проекта, результатов маркетингового анализа. Укажите наличие производственных активов для реализации проекта и т.п. Укажите объем средств, потраченных ранее на реализацию проекта.";
      } else {
        return "Опишите существующие результаты по проекту. Укажите, на какой стадии находится разработка нового продукта, наличие прототипа опытно-промышленного образца, интеллектуальной собственности, бизнес-плана, технико-экономического обоснования для реализации проекта, результатов маркетингового анализа. Укажите наличие производственных активов для реализации проекта и т.п. Укажите объем средств, потраченных ранее на реализацию проекта.";
      }
    }
  }
};
</script>

<style scoped></style>
